import { useReducer, useEffect } from 'react';
import ComponentNotifier from '../../../../../services/wss/ComponentNotifier';
import floatingPanelEngine from '../../Core/FloatingPanelEngine';

/**
 * Paint trigger for a single FloatingContentPanel.
 * Subscribes to SearchResultProvider_{panelId} — on notify reads state directly from provider.
 *
 * @param {string} panelId
 * @returns {{ results, total, page, query, topic, selectedEntry, loading, topicOptions }}
 */
export default function useSearchResults(panelId) {
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    useEffect(() => {
        const channel = `SearchResultProvider_${panelId}`;
        const unsub = ComponentNotifier.subscribe(channel, forceUpdate);
        return () => unsub();
    }, [panelId]);

    const provider = floatingPanelEngine.getProvider(panelId);
    return {
        ...provider?.getProps(),
        topicOptions: floatingPanelEngine.getTopicOptions(),
    };
}
